module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-02-2dc5d0365913d0fbdb7beb8cf5e74882.jpg";